export default __webpack_public_path__ + "static/media/hyundai.27b8d7e4.svg";